/**
 * Format a number as USD currency with 2 decimal places
 * @param {number} amount - The amount to format
 * @returns {string} Formatted currency string (e.g., "$5.00")
 */
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

/**
 * Format a number with 2 decimal places (without $ sign)
 * @param {number} amount - The amount to format
 * @returns {string} Formatted number string (e.g., "5.00")
 */
export const formatAmount = (amount) => {
  return Number(amount).toFixed(2);
};

export default formatCurrency;